import { Star } from 'lucide-react';
import type { Bilan } from '../../types';
import { fmtDate } from '../../lib/dates';
import { Badge, type BadgeTone } from '../../components/charte';
import { PrivateNote } from '../../components/lesson/PrivateNote';

// Un résumé de séance enregistré, dans la liste « Résumés des séances ».

const LEVEL_LABEL: Record<string, { label: string; tone: BadgeTone }> = {
  acquis: { label: 'Acquis', tone: 'ok' },
  en_cours: { label: 'En cours', tone: 'warn' },
  a_revoir: { label: 'À revoir', tone: 'danger' },
};

export function BilanItem({ b }: { b: Bilan }) {
  return (
    <li className="space-y-2 rounded-row border border-line p-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span className="text-sm font-semibold text-heading">{fmtDate(b.lessonDate ?? b.createdAt)}</span>
        <div className="flex items-center gap-2">
          {b.readyForExam && <Badge tone="ok">Prêt examen</Badge>}
          {b.rating != null && (
            <span className="flex items-center gap-0.5 text-xs font-semibold text-amber-600">
              <Star size={13} className="fill-amber-400 text-amber-400" aria-hidden />
              {b.rating}/5
            </span>
          )}
        </div>
      </div>
      {b.nextObjective && (
        <p className="rounded-xl bg-surface-indigo px-3 py-2 text-sm text-primary-900">
          <strong>Prochain cours :</strong> {b.nextObjective}
        </p>
      )}
      <p className="whitespace-pre-line text-sm text-body">{b.summary}</p>
      {b.examReason && <p className="text-sm text-secondary">Avis examen : {b.examReason}</p>}
      {b.secretaryAlert && <p className="text-sm text-warn-fg">Secrétariat : {b.secretaryAlert}</p>}
      <PrivateNote text={b.privateNote} />
      {b.competencies.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {b.competencies.map((c, i) => {
            const meta = LEVEL_LABEL[c.level] ?? { label: c.level, tone: 'mute' as BadgeTone };
            return (
              <Badge key={`${c.label}-${i}`} tone={meta.tone}>
                {c.label} · {meta.label}
              </Badge>
            );
          })}
        </div>
      )}
    </li>
  );
}
